/**
 * O que a conversão em Item de Trabalho lembra da vez anterior
 * (SPEC-20260918-2146).
 *
 * Quem converte linhas de checklist quase nunca converte uma só: vai uma atrás
 * da outra, e quase sempre com o mesmo tipo, o mesmo status e a mesma área. Ter
 * de reescolher tudo a cada linha é trabalho repetido à toa.
 *
 * O que NÃO se lembra é a descrição: ela é conteúdo daquele item específico, e
 * repetir texto de um item no seguinte seria erro disfarçado de conveniência.
 *
 * Fica no navegador, por pessoa e por computador. É preferência de quem
 * trabalha, não dado do workspace — e nunca vale como padrão para outra pessoa.
 */

export type EscolhasDaConversao = {
  workItemTypeId: string
  workItemStatusId: string
  workItemPriorityId: string
  companyAreaId: string
  flowStepId: string
}

const CHAVE = 'orbind.converter-item.ultimas-escolhas'

export function escolhasLembradas(): Partial<EscolhasDaConversao> {
  try {
    const cru = localStorage.getItem(CHAVE)
    if (!cru) return {}
    const o = JSON.parse(cru) as Record<string, unknown>
    const texto = (v: unknown) => (typeof v === 'string' ? v : undefined)
    return {
      workItemTypeId: texto(o.workItemTypeId),
      workItemStatusId: texto(o.workItemStatusId),
      workItemPriorityId: texto(o.workItemPriorityId),
      companyAreaId: texto(o.companyAreaId),
      flowStepId: texto(o.flowStepId),
    }
  } catch {
    return {}
  }
}

export function lembrarEscolhas(e: EscolhasDaConversao): void {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(e))
  } catch {
    /* sem storage: a conversão funciona igual, só não lembra */
  }
}

/**
 * O valor a usar num campo: o lembrado, se ele AINDA EXISTE entre as opções de
 * hoje; senão o padrão.
 *
 * A checagem importa porque catálogo é cadastrável: o tipo escolhido semana
 * passada pode ter sido desativado, e restaurar um id morto deixaria o campo
 * em branco sem explicação — ou, pior, mandaria um id inválido ao servidor.
 */
export function escolhaValida(
  lembrado: string | undefined,
  opcoes: readonly { id: string }[],
  padrao: string,
): string {
  if (lembrado && opcoes.some((o) => o.id === lembrado)) return lembrado
  return padrao
}
